@if (actionParams) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="actionParams">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Description </label>
            </div>
            <ng-container *ngTemplateOutlet="validators; context: { myControlName: 'description', myForm: actionParams}"></ng-container>
            <input class="control-input" activeForm [activeForm]="actionParams" id="description" [formControlName]="'description'" placeholder="Enter description"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Variable(s) </label>
            </div>
            @for (logicOption of actionVariables.controls.variables.controls; track logicOption; let index = $index) {
              <div class="control-container" [formGroup]="logicOption">
                <span class="control-container-header">
                  <label class="label">
                    {{actionVariables.controls.variables.controls[index].controls.variableName.value !== '' ? actionVariables.controls.variables.controls[index].controls.variableName.value : '[Variable Name]' }}
                  </label>
                  <img class="deleteBtn" src="../../../../../../../../assets/svg/delete-bin.svg" alt="delete variable" (click)="onDeleteVariable(index, actionVariables.controls.variables, false)">
                </span>
                <ng-container *ngTemplateOutlet="validators; context: { myControlName: 'variableName', myForm: logicOption}"></ng-container>
                <input class="control-input control-container-variable" [formControlName]="'variableName'" placeholder="Variable Name"/>
                <input class="control-input control-container-variable" [formControlName]="'variableValue'" placeholder="Variable Value"/>
              </div>
            }
            <div class="addBtnContainer">
              <button class="addIcon" (click)="onAddVariable(actionVariables.controls.variables)">
                Add New Variable
              </button>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </clickatell-expansion-panel>
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Logic
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container>
          <div class="control-div">
            <label class="control-label"> Point To </label>
            <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
            @if (nodeFlowDetails) {
              <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
                [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
                [name]="'success'"
                [form]="actionParams"
                [stepId]="nodeFlowDetails.stepId">
              ></next-selector>
            }
          </div>
        </ng-container>
      </ng-container>
    </clickatell-expansion-panel>
  </div>
}

<ng-template #validators let-myControlName="myControlName" let-myForm=myForm>
  @if (myForm.controls[myControlName]; as control) {
    @if (control.invalid && (control.dirty || control.touched)) {
      <div class="validationField">
        @for (error of control.errors | keyvalue; track error) {
          <div>
            <span class="fa fa-exclamation-circle"></span>
            <span [id]="'validationField-' + myControlName">
              {{error.value}}
            </span>
          </div>
        }
      </div>
    }
  }
</ng-template>
